<template>
  <div>
      <input
        v-show="inPercentage === false"
        class="form-control simple text-right"
        v-model="computedInputValue"
      />
      <input
        v-show="inPercentage === true"
        class="form-control simple text-right"
        v-model="computedInputPercentValue"
      />
  </div>
</template>

<script>
import { calculatePercentage } from '../../../helpers/math';

export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    remaining: {
      type: Number,
      default: 0
    },
    inPercentage: {
      type: Boolean,
      default: false
    },
    handleValueChange: {
      type: Function,
      default: () => {}
    },
  },

  computed: {
    computedInputValue: {
      get () {
        return this.value;
      },
      set (value) {
        this.handleValueChange(value);
      }
    },
    computedInputPercentValue: {
      get () {
        return calculatePercentage(this.value, this.remaining);
      },
      set (value) {
        this.handleValueChange((this.remaining * value) / 100);
      }
    },
  },
};
</script>
